import { Trans } from 'react-i18next';
import ModeStandbyIcon from '@mui/icons-material/ModeStandby';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { NotificationPresenter } from '@notifications/interfaces';
import { ShootingClearanceGrantedNotificationData } from './interfaces';
import { ShootingClearanceCategory } from '@api/shootingApi/interfaces';
import { clearanceCategoryLabel } from '@helpers/clearanceCategories';
import i18n from '@translations/i18n';

const isShootingClearanceGrantedPayload = (
  payload: unknown
): payload is ShootingClearanceGrantedNotificationData => {
  if (typeof payload !== 'object' || payload === null) {
    return false;
  }

  return (
    'clearanceCategory' in payload &&
    typeof payload.clearanceCategory === 'string' &&
    'clearedOn' in payload &&
    typeof payload.clearedOn === 'string'
  );
};

const categoryLabel = (category: string): string =>
  clearanceCategoryLabel(category as ShootingClearanceCategory, i18n.t);

export const shootingClearanceGrantedPresenter: NotificationPresenter<ShootingClearanceGrantedNotificationData> =
  {
    type: 'shooting-clearance-granted',
    icon: ModeStandbyIcon,
    badgeIcon: CheckCircleIcon,
    isPayload: isShootingClearanceGrantedPayload,
    label: (payload, t) =>
      t('notifications:types.shooting-clearance-granted', {
        category: categoryLabel(payload.clearanceCategory),
      }),
    message: (payload) => (
      <Trans
        i18nKey="notifications:menu.shooting-clearance-granted"
        values={{
          category: categoryLabel(payload.clearanceCategory),
        }}
        components={{
          bold: <strong />,
        }}
      />
    ),
    path: () => '/profile',
  };
